import { render, staticRenderFns } from "./dataBox6.vue?vue&type=template&id=760e40b0&scoped=true&"
import script from "./dataBox6.vue?vue&type=script&lang=ts&"
export * from "./dataBox6.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox6.vue?vue&type=style&index=0&id=760e40b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760e40b0",
  null
  
)

export default component.exports